// Functionals import
import React from 'react';
import SpaceX from '../assets/SpaceX.svg';

const Footer = () => {
    return (
        <footer>
            <div className="footer-container">
                <img src={SpaceX} alt="Logo SpaceX" style={{ width: 200, display: 'flex', margin: 'auto' }} />
            </div>
            <br />
        </footer>
    )
};

export default Footer;